exports.default = {
  'cancel': 'Cancel',
  'confirm': 'Confirm',
  'submit': 'Submit',
  'confirm_upload': 'Confirm Upload',
  'copy_success': 'Copy successful',
  'copy_failed': 'Copy failed, please try again later!',
  'delete': 'Delete',
  'upload_image': 'Upload Image',
  'copy': 'Copy',
  'close': 'Close',
  'operation_failed': 'Operation failed, please try again later',
  'operation_success': 'Operation successful!',
  'form_not_complete': 'Form is incomplete, please check and resubmit!',
  'executing': 'Executing...',
  'crop_image': 'Crop Image',
  'crop': 'Crop',
  'tips': 'Tip',
  'refresh': 'Refresh',
  'upload_without_crop': 'Upload without cropping',
  'save_success': 'Save successful!',
  'image_type_error': 'Image type must be one of: .gif, jpeg, jpg, png, bmp',
  'add_success': 'Added successfully',
  'verification_failed': 'Verification code validation failed',
  'loading': 'Loading',
  'no_more': 'No more',
  'your_agents': 'Your agents',
  'edit_avatar': 'Edit avatar',
  'save_note': 'Save note',
  'share': 'Share',
  'network_error': 'Network error, sending failed.',
  'single_image_size_no_more_than_50M': 'Single image size should not exceed 20MB, up to 10 images can be uploaded at once.',
  'please_enter_your_question_or_requirement': 'Please enter your question or requirement. Press Enter to send message, Ctrl+Enter / Shift+Enter for a new line',
  'account_logout_need_relogin': 'The current account has been logged out, please log in again',
  'account_identity_changed_refresh_required': 'The identity of the currently logged-in account has changed. Please refresh and try again.',
  'team_disbanded_switch_notice': 'The current team has been disbanded. You will be switched to your personal team in 3 seconds.',
  'team_membership_lost_switch_notice': 'You are no longer a member of the current team. You will be switched to your personal team in 3 seconds.',
  'invalid_webpage': 'Invalid Webpage'
}
